import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'

const ActionMenu = ({ options }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        size="small"
        style={{ margin: '-8px -7px 0 0' }}
      >
        <MoreVertIcon style={{ height: 20 }} />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            padding: '0 8px',
          },
        }}
      >
        {options.map(option => {
          const styles = { fontSize: 14, ...(option ? option.style : {}) }
          const onClick = () => {
            option.onClick()
            handleClose()
          }
          return (
            <MenuItem key={option.id} onClick={onClick} style={styles}>
              {option.name}
            </MenuItem>
          )
        })}
      </Menu>
    </div>
  )
}

export default ActionMenu
